import React, { Fragment, useEffect, useState } from "react";
import { CardBody, Col, Row, Table, Button, Input, Form } from "reactstrap";
import { Link } from "react-router-dom";
import { TextInput } from "../FormInputs";
import {
  Column,
  Table as ReactTable,
  ColumnFiltersState,
  FilterFn,
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  flexRender
} from '@tanstack/react-table';
import Dragula from 'react-dragula';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { rankItem } from '@tanstack/match-sorter-utils';
import { useSelector, useDispatch } from "react-redux";
import { setinitial_page1, setsorting_data1 } from "../../../slices/globalslice";
import useNavigationMenu from "../../../hooks/useNavigationMenu";
import Loader2 from "../Loader2";

const TableContainer1 = ({
  columns,
  isLoading,
  data,
  total,
  pagechange,
  disableSearch,
  customPageSize,
  tableClass,
  draggable,
  trClass,
  thClass,
  divClass,
  disableNavigation,
}) => {
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const { updatemenudisplay } = useNavigationMenu()
  const dispatch = useDispatch()
  const [sorting, setSorting] = useState([]);

  const initial_page1 = useSelector(state => state.globalslice.initial_page1);
  const sorting_data1 = useSelector(state => state.globalslice.sorting_data1);
  const queryClient = useQueryClient();

  const fuzzyFilter = (row, columnId, value, addMeta) => {
    const itemRank = rankItem(row.getValue(columnId), value);
    addMeta({ itemRank });
    return itemRank.passed;
  };

  const isMobile = window.innerWidth <= 576;

  const table = useReactTable({
    columns,
    data,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    state: {
      columnFilters,
      globalFilter,
      sorting,
    },
    manualPagination: true,
    manualSorting: true,
    enableSortingRemoval: false,
    onSortingChange: (updater) => {
      const newSorting = typeof updater === 'function' ? updater(sorting) : updater;
      setSorting(newSorting);
      table.setPageIndex(0);
    },
    pageCount: Math.ceil(total / customPageSize),
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: fuzzyFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel()
  });

  const {
    getHeaderGroups,
    getRowModel,
    getCanPreviousPage,
    getCanNextPage,
    getPageOptions,
    setPageIndex,
    nextPage,
    previousPage,
    setPageSize,
    getState
  } = table;

  useEffect(() => {
    customPageSize && setPageSize(customPageSize);
  }, [customPageSize, setPageSize]);

  useEffect(() => {
    const pageIndex = table.getState().pagination.pageIndex;
    dispatch(setinitial_page1(pageIndex + 1));
  }, [table.getState().pagination.pageIndex]);

  useEffect(() => {
    if (pagechange !== undefined) {
      table.setPageIndex(0);
      dispatch(setinitial_page1(1));
    }
  }, [pagechange]);

  useEffect(() => {
    dispatch(setsorting_data1({}))
  }, [])




  useEffect(() => {
    // Call your API with pagination and sorting parameters
    const pageIndex = table.getState().pagination.pageIndex;
    const pageSize = table.getState().pagination.pageSize;
    const sortBy = sorting.length ? sorting[0].id : '';
    const sortOrder = sorting.length ? sorting[0].desc ? 'desc' : 'asc' : '';



    if (sortBy != '' && sortOrder != '') {
      dispatch(setsorting_data1({
        sortBy: sortBy,
        sortOrder: sortOrder
      }))
    }

    dispatch(setinitial_page1(pageIndex + 1));
  }, [table.getState().pagination.pageIndex, sorting]);


  const ASC_ICON = '▲'; // Unicode character for ascending arrow
  const DESC_ICON = '▼'; // Unicode character for descending arrow
  const [search_value, setsearch_value] = useState('');

  const handleChange = (e) => {
    setsearch_value(e.target.value);
  }

  const handleSubmit = () => {
    dispatch(setsorting_data1({
      ...sorting_data1,
      search: search_value
    }))
    dispatch(setinitial_page1(1));
  }

  const dragulaDecorator = (componentBackingInstance) => {
    if (draggable && componentBackingInstance) {
      const drake = Dragula([componentBackingInstance]);

      drake.on('drop', (el, target) => {
        const rows = target.querySelectorAll("tr");
        const newOrder = Array.from(rows).map((row, index) => ({
          id: row.getAttribute("data-id"),
          position: index + 1
        }));

        const input_data = {
          type: 'menu',
          data: newOrder
        };

        // Now update backend
        updatemenudisplay.mutate(input_data, {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['menu_list'] });
          }
        });

        // Prevent Dragula from moving elements, force React to handle it
        drake.cancel(true);
      });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit()
    }
  };
  return (
    <Fragment>

      <>
        {
          isLoading ?
            <div style={{ height: '400px' }} className="d-flex justify-content-center align-items-center">
              <Loader2 />
            </div>

            :
            <>
              {
                disableSearch == undefined &&
                <div className="d-flex justify-content-end mb-3 ">
                  <Input type="text" className="form-control-sm search_custom_width" onChange={handleChange} onKeyDown={handleKeyDown} />
                  <Button color="primary" className="btn-icon btn-sm ms-2" onClick={handleSubmit}> <i className="ri-search-line" /> </Button>
                </div>

              }
              <>
                {
                  data?.length <= 0 ?
                    <div className="d-flex justify-content-center">
                      No Data found
                    </div>
                    :
                    <>
                      <div className={`${divClass} max-w-full ${isMobile && 'overflow-x-scroll'} overflow-y-hidden`}>

                        <Table hover className={`${tableClass} w-full table-sm`}>
                          <thead className={'table-light'}>
                            {getHeaderGroups().map((headerGroup) => (
                              <tr className={trClass} key={headerGroup.id}>
                                {headerGroup.headers.map((header) => (
                                  <th
                                    key={header.id}
                                    className={`${thClass} cursor-pointer`}
                                    {...{
                                      onClick: header.column.getToggleSortingHandler(),
                                    }}
                                  >
                                    {header.isPlaceholder ? null : (
                                      <>
                                        {flexRender(
                                          header.column.columnDef.header,
                                          header.getContext()
                                        )}
                                        <span className="ms-1" >
                                          {header.column.getIsSorted() === 'asc' && ASC_ICON}
                                          {header.column.getIsSorted() === 'desc' && DESC_ICON}
                                        </span>
                                      </>
                                    )}
                                  </th>
                                ))}
                              </tr>
                            ))}
                          </thead>
                          <tbody ref={dragulaDecorator}>
                            {getRowModel().rows.map((row) => (
                              <tr key={row.id} data-id={row.original.id || row.original.menuid}>
                                {row.getVisibleCells().map((cell) => (
                                  <td key={cell.id}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>

                      {
                        disableNavigation == undefined &&
                        <Row className="align-items-center mt-2 g-3 text-center text-sm-start">
                          <div className="col-sm">
                            <div className="text-muted">
                              Showing <span className="fw-semibold ms-1">{data.length * initial_page1}</span> of <span className="fw-semibold">{total}</span> Results
                            </div>
                          </div>
                          <div className="col-sm-auto">
                            <ul className="pagination pagination-separated pagination-md justify-content-center justify-content-sm-start mb-0">
                              <li className={!getCanPreviousPage() ? "page-item disabled" : "page-item"}>
                                <Link to="#" className="page-link" onClick={previousPage}>{isMobile ? '<' : 'Previous'}</Link>
                              </li>

                              {/* Custom Pagination Rendering */}
                              {(() => {
                                const currentPage = getState().pagination.pageIndex;
                                const totalPages = getPageOptions().length;
                                const visiblePages = isMobile ? 2 : 5;

                                const pages = [];
                                const half = Math.floor(visiblePages / 2);
                                let start = Math.max(0, currentPage - half);
                                let end = start + visiblePages;
                                if (end > totalPages) {
                                  end = totalPages;
                                  start = Math.max(0, end - visiblePages);
                                }
                                if (start > 0) {
                                  pages.push(
                                    <li key="first" className="page-item">
                                      <Link to="#" className="page-link" onClick={() => setPageIndex(0)}>1</Link>
                                    </li>
                                  );
                                  if (start > 1) {
                                    pages.push(
                                      <li key="start-dots" className="page-item disabled">
                                        <span className="page-link">...</span>
                                      </li>
                                    );
                                  }
                                }
                                for (let i = start; i < end; i++) {
                                  pages.push(
                                    <li key={i} className="page-item">
                                      <Link
                                        to="#"
                                        className={currentPage === i ? "page-link active" : "page-link"}
                                        onClick={() => setPageIndex(i)}
                                      >
                                        {i + 1}
                                      </Link>
                                    </li>
                                  );
                                }

                                if (end < totalPages) {
                                  if (end < totalPages - 1) {
                                    pages.push(
                                      <li key="end-dots" className="page-item disabled">
                                        <span className="page-link">...</span>
                                      </li>
                                    );
                                  }
                                  pages.push(
                                    <li key="last" className="page-item">
                                      <Link to="#" className="page-link" onClick={() => setPageIndex(totalPages - 1)}>{totalPages}</Link>
                                    </li>
                                  );
                                }

                                return pages;
                              })()}

                              <li className={!getCanNextPage() ? "page-item disabled" : "page-item"}>
                                <Link to="#" className="page-link" onClick={nextPage}>{isMobile ? '>' : 'Next'}</Link>
                              </li>
                            </ul>
                          </div>
                        </Row>
                      }
                    </>
                }

              </>
            </>

        }

      </>

    </Fragment >
  );
};

export default TableContainer1;
